'use strict';

export default function() {
  document.cookie = 'garminConnectError='; //clear garmin error cookie on load

  function disconnectGarmin() {
    $.ajax({
      type: 'POST',
      url: '/oauth/garmin_connect/disconnect',
      success: function(response) {
        if (response.result === true) {
          //TODO: for now we reload page; will convert to dynamic ajax section reload
          location.reload();
        } else {
          //TODO: something user friendly
          console.log('Diconnecting Garmin failed, returned false.');
        }
      },
      error: function() {
        //TODO: something user friendly
        console.log('Error disconnecting Garmin.');
      },
    });
  }

  $('#eula-modal__button-accept').on('click', function() {
    $('#authorizationForm').submit();
    $.ajax({
      type: 'POST',
      url: '/my-account/integrations/',
      success: function() {
        //console.log(data);
      },
      error: function() {
        console.log('error');
      },
    });
  });

  $('#authorizationForm').on('submit', function(e) {
    e.preventDefault();
    var frame = $('#eula-modal');
    var left = window.screenX + frame.offset().left;
    var top = window.screenY + (window.outerHeight - window.innerHeight) + frame.position().top;
    var width = frame.css('width');
    var height = frame.css('height');
    window.open(
      this.action,
      'Garmin Connect with your Trek Device',
      'height=' + height + ', width=' + width + ', top=' + top + ', left=' + left + ', scrollbars=yes'
    );
  });

  $('#garmin-disconnect').on('click', function() {
    localStorage.removeItem('garminConnectedPrompt');
    return disconnectGarmin();
  });
  $(document).ready(function() {
    //set the preferred retailer into local storage for quicker access

    var garminPromptUser = localStorage.getItem('garminConnectedPrompt');
    var garminErrorCode = localStorage.getItem('passGarminConnectedError');

    if (garminErrorCode == 'true') {
      document.cookie = 'garminConnectError=' + garminErrorCode; //send garmin error cookie to controller
      localStorage.removeItem('passGarminConnectedError');
    }

    if (garminPromptUser == 'true') {
      $('#success-msg').foundation('open');
      localStorage.setItem('garminConnectedPrompt', false);
    }

    $('.sprocket__modal').removeClass('invisible');
  });
}
